var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoLandFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.049 299L226.513 400.369C226.926 401.109 227.383 401.828 227.881 402.521L228 402.707H228.017C232.665 409.035 240.774 413.226 250 413.226C259.226 413.226 267.335 409.035 271.983 402.707H272L272.115 402.526C272.616 401.829 273.076 401.108 273.49 400.364L337.951 299H382.345C388.174 299 393.713 301.543 397.512 305.963L493.128 440.463C504.275 453.431 495.062 473.5 477.961 473.5H250.027V450H249.973V473.5H22.0387C4.93831 473.5 -4.27515 453.431 6.87197 440.463L102.488 305.963C106.287 301.543 111.826 299 117.655 299H162.049Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372 143.5C372 167.211 365.263 189.349 353.599 208.104L266.939 359.517C266.631 360.129 266.291 360.723 265.92 361.297L265.833 361.448H265.821C262.37 366.668 256.35 370.125 249.5 370.125C242.65 370.125 236.63 366.668 233.179 361.448H233.167L233.079 361.295C232.709 360.723 232.369 360.13 232.062 359.518L145.401 208.104C133.737 189.349 127 167.211 127 143.5C127 75.8451 181.845 21 249.5 21C317.155 21 372 75.8451 372 143.5ZM248.99 207.813C284.79 207.813 313.813 178.79 313.813 142.99C313.813 107.189 284.79 78.1667 248.99 78.1667C213.189 78.1667 184.167 107.189 184.167 142.99C184.167 178.79 213.189 207.813 248.99 207.813Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLandFill);
export default __webpack_public_path__ + "static/media/ico_land_fill.c81aee79a8389947576e2ea76b275f53.svg";
export { ForwardRef as ReactComponent };